export default __webpack_public_path__ + "static/pyatyorochka-b91beb0e0715879756050966dc9ad899.webp";